import React from 'react';

const NotAllowedPage: React.FC<{}> = () => {
  return <div>You do not have permission to see this page</div>;
};

export default NotAllowedPage;
